<template>
  <page-edicion>
    <formulario-campania :campania="campania" :descuentos="descuentos" @submit="actualizar" />
  </page-edicion>
</template>

<script>
import { mapActions } from "pinia";
import FormularioCampania from "./FormularioCampania.vue";
import api from "@/services/campanias.js";

export default {
  components: { FormularioCampania },
  data() {
    return {
      campania: {},
      descuentos: [],
    };
  },
  mounted() {
    this.cargar(this.$route.params.id);
  },
  methods: {
    async cargar(id) {
      let datosCampania = await api.cargar(id);
      this.campania = datosCampania.campania;
      this.descuentos = datosCampania.descuentos;
    },
    async actualizar() {
      await api.actualizar(this.campania, this.descuentos);
      this.$messages.success("Se ha actualizado la campaña");
      this.$router.push({ path: "/campanias" });
    },
  },
};
</script>
